import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-title" }, " Visualizza log delle ultime richieste ", -1)
const _hoisted_4 = { class: "my-card mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold my-card--header" }, " Actions ", -1)
const _hoisted_6 = { class: "my-buttons my-card--body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Aggiorna lista ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Precedente ")
const _hoisted_9 = { class: "mx-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Successiva ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Filtra ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Help ")
const _hoisted_13 = { class: "container" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "my-title" }, "Dettagli", -1)
const _hoisted_15 = {
  key: 0,
  class: "my-codeblock is-center is-error"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, "Informazioni richiesta", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, "Corpo richiesta", -1)
const _hoisted_18 = { class: "my-codeblock is-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, "Header richiesta", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, "Claim del token Authorization", -1)
const _hoisted_21 = { class: "text-center p-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, "Informazioni risposta", -1)
const _hoisted_23 = {
  key: 1,
  class: "text-center mb-5"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Il codice ritornato dal server è ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, "Corpo risposta", -1)
const _hoisted_28 = { class: "my-codeblock is-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, " Copia richiesta come comando curl ", -1)
const _hoisted_30 = { class: "my-codeblock text-left" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, "Id server della richiesta", -1)
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "container" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "my-title" }, " Filtra risultati ", -1)
const _hoisted_35 = { class: "my-form" }
const _hoisted_36 = { class: "my-form--field" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, " Visualizza solo gli errori? ", -1)
const _hoisted_38 = { class: "my-form--field--field" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Si", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "No", -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "my-form--field" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, " Filtra per metodo ", -1)
const _hoisted_44 = { class: "my-form--field--field" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Tutti", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "GET" }, "GET", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "POST" }, "POST", -1)
const _hoisted_48 = [
  _hoisted_45,
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { class: "my-form--field" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, " Filtra per tipo ", -1)
const _hoisted_51 = { class: "my-form--field--field" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "machine" }, "Macchina", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", { value: "account" }, "Account", -1)
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "my-form--field" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, " Filtra per codice seriale ", -1)
const _hoisted_57 = { class: "my-form--field--field" }
const _hoisted_58 = { class: "my-form--field" }
const _hoisted_59 = { class: "my-form--field--field" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_61 = { class: "my-form--field--field" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Filtra ")
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-title" }, " Informazioni sulle opzioni sviluppatore "),
  /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle" }, " Log delle richieste "),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" In questa pagina sono mostrate le richieste effettuate dalle macchine che sono pervenute al server. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Per ogni richiesta si possono ispezionare i dettagli della richiesta, ad esempio metodo, header che sono stati inviati e corpo della richiesta (se presente). Oltre a questo si può visualizzare il codice ritornato dal server per quella particolare richiesta. Le richieste problematiche (cioè quelle per cui il server ha ritornato un codice di errore) sono evidenziate in rosso. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" È possibile quindi debuggare eventuali richieste fallite o dati che non vengono inseriti nel database. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Notare che eventuali richieste che non contengono il token di autenticazione sono rigettate, ma non sono presenti in questa lista. In altre parole una richiesta per essere visibile qui deve essere almeno autenticata correttamente. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Sono elencati qui sotto alcuni degli errori più comuni, e relative cause e soluzioni. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("b", null, "Errore 400"),
    /*#__PURE__*/_createTextVNode(" viene ritornato dal server quando la richiesta che è stata fatta in qualche modo è errata. Ad esempio se la richiesta contiene una querystring (?key=value&...) e un parametro deve essere numerico, se viene passata una stringa il server risponde con errore 400 (in quanto non sa come trasformare una stringa con lettere in un numero intero). Controllare quindi che la richiesta sia formata correttamente. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("b", null, "Errore 403"),
    /*#__PURE__*/_createTextVNode(" è causato dal tentativo di effettuare una operazione che non si è autorizzati a fare. Ad esempio un account loggato come utente normale tenta di effettuare delle operazioni che sono permesse solo ad un utente amministratore. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("b", null, "Errore 404"),
    /*#__PURE__*/_createTextVNode(" significa che probabilmente il path è errato. Controllare che il percorso sia scritto correttamente. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("b", null, "Errore 405"),
    /*#__PURE__*/_createTextVNode(" indica un metodo http non supportato oppure errato. Controllare che per il path specificato il metodo inviato sia quello corretto (GET oppure POST, a seconda dei casi). "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("b", null, "Errore 415"),
    /*#__PURE__*/_createTextVNode(" segnala che il dato che si è inviato al server non è nel formato che il server si aspetta. Solitamente (nelle richieste dove il body è in formato json) questo è causato dalla mancanza dell'header http "),
    /*#__PURE__*/_createElementVNode("i", null, "Content-Type"),
    /*#__PURE__*/_createTextVNode(", che deve assumere il valore "),
    /*#__PURE__*/_createElementVNode("i", null, "application/json"),
    /*#__PURE__*/_createTextVNode(". Se è questo il caso assicurarsi che l'header sia presente e sia scritto correttamente. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" In alcuni casi è possibile che una richiesta sia malformata in un modo che ne prevenga anche l'arrivo al server, e quindi non appaia in questa lista. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Alcune cose da controllare in questi casi sono "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Aver inserito nella richiesta POST l'header Content-Length e che sia corretto, nel caso l'header non sia presente la richiesta fallisce con un errore 411 Length Required. Oppure che si sia inserito il corpo di una richiesta POST, infatti se il server non trova il corpo rimane in attesa che arrivi per un certo tempo e poi la richiesta termina con un errore 408 Request Timeout. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-sync",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshData(0)))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-arrow-left",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshData(_ctx.page - 1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, " Pagina " + _toDisplayString(_ctx.page + 1), 1),
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-arrow-right",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshData(_ctx.page + 1)))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            icon: "fas fa-search",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalFilter = true)),
            class: _normalizeClass(_ctx.filterErrors !== 0 || _ctx.filterMethod !== '' ? 'is-success' : 'is-secondary')
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-info-circle",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModalHelp = true))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_Table, {
        data: _ctx.listRequests,
        config: _ctx.configTable,
        onViewDetailRequest: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModalDetail($event)))
      }, null, 8, ["data", "config"])
    ]),
    _createVNode(_component_Modal, {
      isShowing: _ctx.showModalDetails,
      classes: "w-5/6 lg:w-2/3",
      onCloseModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModalDetails = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          (_ctx.selectedRequest.errorDescription.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.selectedRequest.errorDescription), 1))
            : _createCommentVNode("", true),
          _hoisted_16,
          _createVNode(_component_Table, {
            config: _ctx.configTableDetails,
            data: _ctx.filter(_ctx.toPairs(_ctx.selectedRequest.request),
            d => d[0] !== 'headers' && d[0] !== 'body')
          }, null, 8, ["config", "data"]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.selectedRequest.request.body === ''
            ? 'Non presente o vuoto' : _ctx.selectedRequest.request.body), 1),
          _hoisted_19,
          _createVNode(_component_Table, {
            config: _ctx.configTableDetails,
            data: _ctx.selectedRequest.request.headers
          }, null, 8, ["config", "data"]),
          _hoisted_20,
          _createVNode(_component_Table, {
            config: _ctx.configTableDetails,
            data: _ctx.toPairs(_ctx.selectedRequest.claims)
          }, null, 8, ["config", "data"]),
          _createElementVNode("div", _hoisted_21, " Scadenza del token: " + _toDisplayString(new Date(_ctx.selectedRequest.claims.exp * 1000).toLocaleString()), 1),
          _hoisted_22,
          (_ctx.selectedRequest.response.status_code >= 100
          && _ctx.selectedRequest.response.status_code <= 599)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("b", null, _toDisplayString(_ctx.selectedRequest.response.status_code), 1),
                _hoisted_25,
                _createElementVNode("a", {
                  class: "text-blue-600",
                  target: "_blank",
                  href: `https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/${_ctx.selectedRequest.response.status_code}`
                }, " Link documentazione per il codice " + _toDisplayString(_ctx.selectedRequest.response.status_code), 9, _hoisted_26)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Table, {
            config: _ctx.configTableDetails,
            data: _ctx.filter(_ctx.toPairs(_ctx.selectedRequest.response), d => d[0] !== 'body')
          }, null, 8, ["config", "data"]),
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.selectedRequest.response.body === '' || !_ctx.selectedRequest.response.body ?
            'Non presente o vuoto' : _ctx.selectedRequest.response.body), 1)
        ]),
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.createCurlCommand(_ctx.selectedRequest)), 1),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.selectedRequest.trace_id), 1)
      ]),
      _: 1
    }, 8, ["isShowing"]),
    _createVNode(_component_Modal, {
      isShowing: _ctx.showModalFilter,
      classes: "w-5/6 lg:w-1/2",
      onCloseModal: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showModalFilter = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("select", {
                  class: "my-input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterErrors) = $event))
                }, _hoisted_41, 512), [
                  [_vModelSelect, _ctx.filterErrors]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("select", {
                  class: "my-input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterMethod) = $event))
                }, _hoisted_48, 512), [
                  [_vModelSelect, _ctx.filterMethod]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _withDirectives(_createElementVNode("select", {
                  class: "my-input",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterEntityType) = $event))
                }, _hoisted_54, 512), [
                  [_vModelSelect, _ctx.filterEntityType]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _withDirectives(_createElementVNode("input", {
                  class: "my-input",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filterEntityId) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.filterEntityId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_Button, {
                  class: "is-primary",
                  icon: "fas fa-eraser",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.filterErrors = 0; _ctx.filterMethod = ''; _ctx.filterEntityId = '';})
                }, {
                  default: _withCtx(() => [
                    _hoisted_60
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_Button, {
                  class: "is-primary",
                  icon: "fas fa-search",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.refreshData(0); _ctx.showModalFilter = false})
                }, {
                  default: _withCtx(() => [
                    _hoisted_62
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShowing"]),
    _createVNode(_component_Modal, {
      isShowing: _ctx.showModalHelp,
      classes: "w-5/6 lg:w-1/3",
      onCloseModal: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showModalHelp = false))
    }, {
      default: _withCtx(() => [
        _hoisted_63
      ]),
      _: 1
    }, 8, ["isShowing"])
  ]))
}